//share-extension-data-plugin.service.ts
import { Injectable } from '@angular/core';
import { Capacitor, registerPlugin } from '@capacitor/core';

const _pluginName = 'ShareExtensionDataPlugin';

export class ShareData {
  items: ShareDataItem[] = [];
}
export class ShareDataItem {
  fileName = '';
  type = '';
  url = '';
  webPath = '';
  fileSize = '';
}

export interface ShareExtensionDataPlugin {
  clear(): Promise<void>;
  read(): Promise<ShareData>;
}
const ShareExtensionDataPlugin =
  registerPlugin<ShareExtensionDataPlugin>(_pluginName);

@Injectable()
export class IosShareExtensionDataPluginService {
  async clear(): Promise<void> {
    // NOTE: ShareExtensionDataPlugin is iOS-only. On Android/web, skip silently.
    if (Capacitor.getPlatform() !== 'ios') {
      return;
    }
    if (!Capacitor.isPluginAvailable(_pluginName)) {
      return;
    }
    try {
      await ShareExtensionDataPlugin.clear();
    } catch (e) {
      console.error('[IosShareExtension] clear failed:', e);
    }
  }

  async read(): Promise<ShareDataItem[] | null> {
    // NOTE: ShareExtensionDataPlugin is iOS-only. On Android/web, skip without
    // touching Capacitor plugin registration (avoids noisy logs on every resume).
    if (Capacitor.getPlatform() !== 'ios') {
      return null;
    }
    if (!Capacitor.isPluginAvailable(_pluginName)) {
      return null;
    }
    try {
      const result = await ShareExtensionDataPlugin.read();
      return result?.items ?? null;
    } catch (e) {
      console.error('[IosShareExtension] read failed:', e);
      return null;
    }
  }
}
